import { Text } from '@chakra-ui/react';

const FieldError = ({ error }: { error?: string }) =>
  error ? (
    <Text color="extra.red" fontSize="13px">
      {error}
    </Text>
  ) : null;

export default FieldError;
